import { useContext } from "react";

import type { CartContextInterface } from "../providers/CartUI";
import { CartContext } from "../providers/CartUI";

export function useCartUI(): CartContextInterface {
  return useContext(CartContext);
}
